
import { Product } from '../types';

// Catálogo real do CTT Força e Ação — fotos próprias das armas em estoque.
// PREÇOS: valores de referência de mercado — Rodrigo deve confirmar/ajustar.
export const products: Product[] = [
    {
        id: 100,
        name: "Pistola Taurus PT59S .380 ACP — DESTAQUE CTT",
        caliber: ".380 ACP",
        price: "R$ 3.990,00",
        imageUrls: ["/pt59s.jpg"],
        category: "Pistola",
        description: "A Pistola Taurus PT59S .380 ACP é um clássico de defesa pessoal: ação SA/DA, alta capacidade e acabamento robusto. Ideal para porte e defesa de alto padrão. Assessoria jurídica e de regularização (CR/CRAF) inclusa com o CTT.",
        isPremium: true,
        storeId: 1,
        storeVerified: true,
        isCollectorItem: false,
    },
    {
        id: 1,
        name: "Pistola Taurus G2C",
        caliber: "9mm",
        price: "R$ 2.900,00",
        imageUrls: ["/g2c.jpg"],
        category: "Pistola",
        description: "A Taurus G2C é compacta, ergonômica e leve — referência em custo-benefício para porte velado e defesa pessoal. Armação em polímero, ferrolho em aço, mira de 3 pontos e capacidade 12+1.",
        storeId: 1,
        storeVerified: true,
    },
    {
        id: 2,
        name: "Pistola Taurus G3",
        caliber: "9mm",
        price: "R$ 3.600,00",
        imageUrls: ["/g3.jpg"],
        category: "Pistola",
        description: "A Taurus G3 full-size eleva o padrão da linha G: gatilho aprimorado, mira metálica de 3 pontos, alta capacidade (15+1/17+1) e excelente ergonomia. Robusta e confiável para defesa e tiro esportivo.",
        isPremium: true,
        storeId: 1,
        storeVerified: true,
    },
    {
        id: 3,
        name: "Pistola Taurus GX4",
        caliber: "9mm",
        price: "R$ 3.900,00",
        imageUrls: ["/gx4.jpg"],
        category: "Pistola",
        description: "A Taurus GX4 é uma micro-compacta 9mm de altíssima capacidade (11+1) num formato ultra discreto. Empunhadura texturizada, ferrolho serrilhado e gatilho leve — o que há de mais moderno em porte velado.",
        isPremium: true,
        storeId: 1,
        storeVerified: true,
    },
    {
        id: 4,
        name: "Pistola Taurus GX4 T.O.R.O. (Optic Ready)",
        caliber: "9mm",
        price: "R$ 4.600,00",
        imageUrls: ["/gx4-toro.jpg"],
        category: "Pistola",
        description: "A GX4 T.O.R.O. vem preparada para red dot (sistema Taurus Optic Ready Option) direto de fábrica. Toda a discrição da GX4 com a vantagem da mira eletrônica para precisão e rapidez na aquisição do alvo.",
        isPremium: true,
        storeId: 1,
        storeVerified: true,
        isCollectorItem: true,
    },
    {
        id: 5,
        name: "Pistola Taurus GX4 .380 ACP",
        caliber: ".380 ACP",
        price: "R$ 3.500,00",
        imageUrls: ["/gx4-380.jpg"],
        category: "Pistola",
        description: "A versão .380 ACP da micro-compacta GX4: recuo mais suave, ótima para quem busca conforto no disparo sem abrir mão da discrição e da alta capacidade. Excelente opção de porte.",
        storeId: 1,
        storeVerified: true,
    },
    {
        id: 6,
        name: "Pistola Taurus GX2",
        caliber: "9mm",
        price: "R$ 3.100,00",
        imageUrls: ["/gx2.jpg"],
        category: "Pistola",
        description: "A Taurus GX2 é a nova entrada da linha GX: 9mm, compacta, simples e confiável, com ótimo custo-benefício. Perfeita para o primeiro armamento do CAC ou defesa residencial.",
        storeId: 1,
        storeVerified: true,
    },
    {
        id: 7,
        name: "Pistola Taurus TH380",
        caliber: ".380 ACP",
        price: "R$ 3.400,00",
        imageUrls: ["/th380.jpg"],
        category: "Pistola",
        description: "A Taurus TH380 traz o sistema de ação dupla/simples (DA/SA) com cão exposto, desarmador e trava manual. Calibre .380 ACP, alta capacidade e ergonomia premium — segurança e conforto para o dia a dia.",
        storeId: 1,
        storeVerified: true,
    },
    {
        id: 8,
        name: "Pistola Taurus TH380 Compact",
        caliber: ".380 ACP",
        price: "R$ 3.300,00",
        imageUrls: ["/th380c.jpg"],
        category: "Pistola",
        description: "A versão Compact da TH380: mesma confiabilidade DA/SA num formato mais curto e discreto, ideal para porte velado. Recuo suave do .380 ACP com a robustez Taurus.",
        storeId: 1,
        storeVerified: true,
    },
    {
        id: 9,
        name: "Munição 9mm Luger CBC — Caixa 50un",
        caliber: "9mm",
        price: "R$ 350,00",
        imageUrls: ["https://images.unsplash.com/photo-1599313689405-2436dce7559e?q=80&w=2000&auto=format&fit=crop"],
        category: "Munição",
        description: "Caixa com 50 munições 9mm Luger CBC, projétil ogival 124gr — ideal para treinamento e habitualidade. Venda controlada para portadores de CR ou registro de arma.",
        storeId: 1,
        storeVerified: true,
    },
];
